import {
  GET_SITE_USERS,
  GET_SITE_USERS_FAILED,
  GET_SITE_USERS_SUCCESS,
  GET_USERS_BY_SEARCH,
  GET_USERS_BY_SEARCH_FAILED,
  GET_USERS_BY_SEARCH_SUCCESS,
  RESET_USERS_BY_SEARCH,
} from "./actionTypes"

export const getSiteUsers = params => ({
  type: GET_SITE_USERS,
  payload: params,
})

export const getSiteUsersSuccess = response => ({
  type: GET_SITE_USERS_SUCCESS,
  payload: response,
})

export const getSiteUsersFailed = error => ({
  type: GET_SITE_USERS_FAILED,
  payload: error,
})

export const getUsersBySearch = params => ({
  type: GET_USERS_BY_SEARCH,
  payload: params,
})

export const getUsersBySearchSuccess = response => ({
  type: GET_USERS_BY_SEARCH_SUCCESS,
  payload: response,
})

export const getUsersBySearchFailed = error => ({
  type: GET_USERS_BY_SEARCH_FAILED,
  payload: error,
})

export const resetUsersBySearch = () => ({
  type: RESET_USERS_BY_SEARCH,
  payload: {},
})
